import { PrismicRichText } from "@prismicio/react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React, { useEffect, useRef } from 'react';

export const SideBySideImage = (props) => {

    const sc = props.slice.primary;

    const items = props.slice.items;

    let bg =
    sc.background === "gradient"
      ? "gradient-to-b from-grey-light to-white"
      : sc.background === "grey"
      ? "grey-light"
      : sc.background === "dark grey"
      ? "grey-d"
      : sc.background;

    let layout = sc.layout === "Left" ? "md:flex-row" : "md:flex-row-reverse";

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }

    const lightBG = ["gradient", "grey", "white"].includes(sc.background) ? sc.background : null;
    const textCheck = lightBG != null ? "text-grey" : "text-white";

    const myRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver(function(entries) {
            const entry = entries[0];
            if(!entry.isIntersecting){
                return;
            }
            entry.target.classList.add('start')

        })
        observer.observe(myRef.current)
    }, [])

    return (
        <section className={'bg-' + bg + ' ' + (sc.theme) + " " + textCheck}>
            <div className={"flex flex-col justify-between items-center " + layout}>
                <div className="w-full md:w-3/5 gutter well">
                <PrismicRichText field={sc.title.richText} components={components} />
                <div className="mb-8"><PrismicRichText field={sc.content.richText} components={components} /></div>
                <div className="flex flex-col gap-4" ref={myRef}>
                {items.map((item, index) => {
                    
                    return (
                        <div key={index} className={"bullet bg-" + item.bullet_background + ' text-' + item.theme + (item.bullet_background === 'transparent' ? ' py-2' : ' p-6')}>
                            {item.icon?.url && (<div className="icon flex items-center w-[50px]"><img src={item.icon.url} className={item.theme} alt="" /></div>)}
                            <div className="w-full"><PrismicRichText field={item.bullet_content.richText} components={components} /></div>
                        </div>
                    )
                })}
                </div>
                {sc.cta_link?.url && (<Link to={sc.cta_link.url} className={"btn mt-12 bg-" + sc.cta_color}>{sc.cta_label}</Link>)}
                </div>
                <div className={"w-full md:w-2/5 flex justify-center self-" + sc.image_alignment}>
                    <GatsbyImage image={getImage(sc.image)} className="md:side-hero" alt={sc.image.alt || sc.title.text} />
                </div>
            </div>
        </section>
    );
}

